import React, { useCallback } from "react";
import { makeStyles } from "@material-ui/core";
import {
  geocodeByPlaceId,
  getLatLng,
  Suggestion,
} from "react-places-autocomplete";
import { FormikConfig } from "formik";

import UserForm from "./components/UserForm";
import { BOT_NAME } from "./const";
import BotLink from "./components/BotLink";
import { Values } from "./types";

const useStyles = makeStyles(() => ({
  app: {
    display: "grid",

    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyItems: "center",

    padding: 24,
  },
  message: {
    textAlign: "center",
  },
}));

const initialValues: Values = {
  name: "",
  date: (null as unknown) as Date,
  time: (null as unknown) as Date,
  place: (null as unknown) as Suggestion,
};

const from = window.location.hash.slice(1);

const App: React.FC = () => {
  const classes = useStyles();

  const handleSubmit: FormikConfig<Values>["onSubmit"] = useCallback(
    async ({ place, date, time, name }) => {
      if (!place) return;

      //  join date and time in date
      date.setHours(time.getHours());
      date.setMinutes(time.getMinutes());

      const geocode = await geocodeByPlaceId(place.placeId);
      const location = await getLatLng(geocode[0]);

      fetch(`${process.env.REACT_APP_API_ENDPOINT}/form`, {
        method: "POST",
        keepalive: true, // send in bg because response can be very slow
        body: JSON.stringify({
          name,
          from,
          location,
          date: date.getTime(),
          offset: -date.getTimezoneOffset(),
        }),
      });

      // open bot after delay
      setTimeout(() => {
        window.location.href = `tg://resolve?domain=${BOT_NAME}`;
      }, 500);
    },
    []
  );

  const validate: FormikConfig<Values>["validate"] = useCallback((values) => {
    const errors = {} as Record<keyof Values, string>;

    if (!values.date) {
      errors.date = "Это обязательное поле";
    }
    if (!values.place) {
      errors.place = "Это обязательное поле";
    }
    if (!values.time) {
      errors.time = "Это обязательное поле";
    }

    return errors;
  }, []);

  return (
    <div className={classes.app}>
      {from ? (
        <UserForm
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validate={validate}
        />
      ) : (
        <BotLink />
      )}
    </div>
  );
};

export default App;
